import React from 'react';
import { Modal, Button } from 'react-bootstrap';

export class ModalGeneral extends React.Component {
  constructor(props) {
    super(props);
    this.handleHide = this.handleHide.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleShow = this.handleShow.bind(this);

    this.state = {
      showModal: props.showInitial || false,
    };
  }

  handleHide(e, callback) {
    if (e) e.preventDefault();
    this.setState({ showModal: false });
    if (callback) callback();
  }

  handleClose(e, callback) {
    this.handleHide(e, callback); // algunos proyectos usan esta función y otros handleHide.
  }

  handleShow() {
    this.setState({ showModal: true });
  }

  render() {
    return (
      <div id="modal-wrap-alert-modal">
        <div className="modal-container">
          <Modal
            show={this.state.showModal}
            container={this.props.container}
            onHide={this.handleHide}
            bsSize="large"
            backdrop="static"
            aria-labelledby="contained-modal-title-lg"
          >
            <Modal.Header>
              <Modal.Title>{this.props.MessageTitle}</Modal.Title>
              <Button className={this.props.NoX + ''} onClick={(e) => this.handleHide(e, this.props.CloseAction)}>
                <i className="fa fa-times"></i>
              </Button>
            </Modal.Header>
            <Modal.Body>
              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 modal-error-body">
                <div
                  className={
                    this.props.Icono !== ''
                      ? 'col-xs-12 col-sm-3 col-md-3 col-lg-3 left-error-modal'
                      : 'col-xs-12 col-sm-2 col-md-2 col-lg-2 left-error-modal'
                  }
                >
                  <i className={this.props.Icono + ' ' + this.props.colorIco + ' icon-error-modal'}></i>
                </div>
                <div
                  className={
                    this.props.Icono !== ''
                      ? 'col-xs-12 col-sm-9 col-md-9 col-lg-9 right-error-modal'
                      : 'col-xs-12 col-sm-10 col-md-10 col-lg-10 right-error-modal'
                  }
                >
                  {this.props.formattedText ? this.props.formattedText : <h4>{this.props.msg}</h4>}
                </div>
              </div>
              <div className="inner-Model-buttons">
                {this.props.MainButtonText && (
                  <Button
                    className={this.props.NoAceptar + ' btn btn-primary btn-si btn-left'}
                    onClick={(e) => this.handleHide(e, this.props.MainButtonAction)}
                  >
                    {this.props.MainButtonText}
                  </Button>
                )}
                <Button
                  className={this.props.NoCancelar + ' btn btn-default btn-no btn-right'}
                  onClick={(e) => this.handleHide(e, this.props.AltButtonAction)}
                >
                  {this.props.AltButtonText}
                </Button>
              </div>
            </Modal.Body>
          </Modal>
        </div>
      </div>
    );
  }
}

export default ModalGeneral;
